import { LabelInterface } from './label.interface';


export class LabelClass implements LabelInterface {
    id: string | number;
    place: string;
    info: string;
    date: Date;
    type: string;

    constructor() {
        this.id = 0;
        this.place = '';
        this.info = '';
        this.date = new Date();
        this.type = '25x70_25x17';
    }

}
